import { useContext, useEffect } from "react";
import { quoteContext } from "../../context/quotesContext";
import { Button } from "../Button";
import "./style.css";
import { SummarOrderSide } from "../SummarOrderSide";
import { DimensionSummary } from "../DimensionSummary";
import { AddressFrom } from "../AddressFrom";
import PaymentOptions from "../PaymentOptions";
import {
  createAdresssCol,
  createAdresssUsa,
  createShipment,
  getAddressCol,
  getAddressUsa,
  getUsaCitiesData,
} from "../api";
import { useTranslation } from "react-i18next";

const SecondStep = () => {
  const [t, i18n] = useTranslation();
  const {
    currentSubStep,
    setCurrentSubStep,
    setLoading,
    stateOption,
    citiesUsa,
    setCitiesUsa,
    setError,
    addressFrom,
    setAdressFrom,
    addressUsa,
    setAddressUsa,
    setCreateShipmentResponse,
    mapNewAdressUsa,
    addressTo,
    setAddressTo,
    addressCol,
    setAddressCol,
    errorBeforePayment,
    setErrorBeforePayment,
    cityOptionSelected,
    mapNewAdressCol,
    mapShipment,
    selectedProvider,
    hanndleCleanNewAdress,
    errorNewAdress, 
    setErrorNewAdress,
    setSelectedProvider
  } = useContext(quoteContext);

  const fetchUSACitiesData = async () => {
    try {
      setLoading(true);
      const result = await getUsaCitiesData({ state: stateOption.state });
      if (result && result.cities) {
        const usaCitiesFiltered = result.cities.map((city) => ({
          ...city,
          label: `${city.city}`,
        }));
        setCitiesUsa(usaCitiesFiltered);
      }
    } catch (error) {
      console.error("Error fetching data getUsaCitiesData", error);
   
    } finally {
      setLoading(false);
    }
  };

  const fetchColAddressData = async () => {
    try {
      setLoading(true);
      const result = await getAddressCol();
      if (result && result.addresses) {
        setAddressCol(result.addresses);
        if (result.addresses.length > 0 && !addressTo) {
          setAddressTo(result.addresses[0].id);
        }
      }
    } catch (error) {
      console.error("Error fetching data  getAddressUsa", error);
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  const fetchUSAAddressData = async () => {
    try {
      setLoading(true);
      const result = await getAddressUsa();
      if (result && result.addresses) {
        setAddressUsa(result.addresses);
        if (result.addresses.length > 0 && !addressFrom)   {
          setAdressFrom(result.addresses[0].id);
        }
      }
    } catch (error) {
      console.error("Error fetching data fetchUSAAddressData", error);
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUSAAddressData();
    fetchUSACitiesData();
    fetchColAddressData();
    setCreateShipmentResponse({
      city_to: cityOptionSelected?.city
    });
  }, []);

  const createAdressUsa = async () => {
    try {
      setLoading(true);
      const data = await createAdresssUsa(mapNewAdressUsa);
      if (data?.length > 0){
        if( data[0].id){
          setAdressFrom(data[0].id);
        }
      }
      
    } catch (error) {
      console.error("Error posting data:", error);
      setErrorNewAdress(true);
      // Handle error, show an error message
    } finally {
      setLoading(false);
      fetchUSAAddressData();
      hanndleCleanNewAdress();
    }
  };

  const createAdressCol = async () => {
    try {
      setLoading(true);

      const data = await createAdresssCol(mapNewAdressCol);
      
      if (data){
        setAddressTo(data.id);
      }
    } catch (error) {
      console.error("Error posting data:", error);
      setErrorNewAdress(true);
      // Handle error, show an error message
    } finally {
      setLoading(false);
      hanndleCleanNewAdress();
      fetchColAddressData();
    }
  };

  const canContinueAddressFrom = () => {
    return addressFrom > 0;
  };

  const canContinueAddressTo = () => {
    return addressTo > 0;
  };

  const addressFromCotinueButton = async () => {
    console.log(selectedProvider)
    try {
      setLoading(true);
      const data = await createShipment({
        ...mapShipment,
        // ...(selectedProvider?.id !== 0 && { rate_options: [selectedProvider] }),
        usa_address_id: addressFrom,
        co_address_id: addressTo,
      });
      if (data && data.rate_options.length === 0) {
        setErrorBeforePayment(true);
        setLoading(false);
        throw new Error();
      } else {
        setCreateShipmentResponse(data);
        setLoading(false);
        setCurrentSubStep(2);
      }
    } catch (error) {
      setLoading(false);
      setErrorBeforePayment(true);
      // Handle error, show an error message
    }
  };

  const addressFromCotinueButtonToPayment = async () => {
    console.log(selectedProvider)
    try {
      setLoading(true);
      const data = await createShipment({
        ...mapShipment,
        ...(selectedProvider?.id !== 0 && { rate_options: [selectedProvider] }),
        usa_address_id: addressFrom,
        co_address_id: addressTo,
      });
      if (data && data.rate_options.length === 0) {
        setErrorBeforePayment(true);
        setLoading(false);
        throw new Error();
      } else {
        setCreateShipmentResponse(data);
        setLoading(false);
        setCurrentSubStep(4);
      }
    } catch (error) {
      setLoading(false);
      setErrorBeforePayment(true);
      // Handle error, show an error message
    }
  };

  if (errorBeforePayment) {
    return <></>;
  }

  return (
    <div className="second-step">
      <h3>
        {currentSubStep === 3 && t("destination_data")}
        {currentSubStep === 4 && t("payment_details")}
      </h3>
      <div className="col-container">
        <div className="col-inpust">
          {currentSubStep === 2 && <DimensionSummary></DimensionSummary>}



            {currentSubStep === 1 && (
            <AddressFrom
              citiesOptions={citiesUsa}
              cityOption={cityOptionSelected}
              selectedAddress={addressFrom}
              onSelectAddressOption={setAdressFrom}
              addressOptions={addressUsa}
              //onClickContinue={() => setCurrentSubStep(2)}
              onClickContinue={addressFromCotinueButton}
              createAdress={createAdressUsa}
              canContinue={canContinueAddressFrom()}
              returnStep={() => setCurrentSubStep(1)}
            ></AddressFrom>
          )}
          {currentSubStep === 3 && (
            <AddressFrom
              selectedAddress={addressTo}
              addressOptions={addressCol}
              onClickContinue={addressFromCotinueButtonToPayment}
              createAdress={createAdressCol}
              canContinue={canContinueAddressTo()}
              onSelectAddressOption={setAddressTo}
              returnStep={() => setCurrentSubStep(2)}
              isColAdress={true}
            ></AddressFrom>
          )}
          {currentSubStep === 4 && <PaymentOptions />}
        </div>
        <div className="col-details">
          <SummarOrderSide></SummarOrderSide>
        </div>
      </div>
    </div>
  );
};

export { SecondStep };
